/**
 * 应用路由组件
 * 集中管理应用的路由配置
 */

import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ROUTES, RouteConfig } from './routes.js';

// Helper component to wrap routes with SEO meta tags
const RouteElement: React.FC<{ route: RouteConfig }> = ({ route }) => {
  const { component: Component, indexable } = route;
  return (
    <>
      {indexable === false && (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      )}
      <Component />
    </>
  );
};

/**
 * 应用路由组件
 */
export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <Routes>
        {Object.values(ROUTES).map(route => {
          const { path, guard: Guard } = route;
          const element = Guard ? (
            <Guard>
              <RouteElement route={route} />
            </Guard>
          ) : (
            <RouteElement route={route} />
          );
          return <Route key={path} path={path} element={element} />;
        })}
        {/* 将来可以添加更多路由 */}
      </Routes>
    </Suspense>
  );
};
